var _g, _rect, _g2, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8427_52847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30709 6.26562C2.05028 7.90081 1.10259 9.7855 0.550781 11.8329H8.8744L3.30709 6.26562Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4485 11.8329C30.8967 9.7855 29.9489 7.90081 28.6922 6.26562L23.125 11.8329H31.4485Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.1797C1.10266 22.2271 2.05034 24.1118 3.30709 25.7469L8.87422 20.1797H0.550781Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7411 3.31106C24.1059 2.05425 22.2213 1.10656 20.1738 0.554688V8.87825L25.7411 3.31106Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25879 28.6921C7.89398 29.9489 9.77866 30.8966 11.826 31.4485V23.125L6.25879 28.6921Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.826 0.554688C9.7786 1.10656 7.89391 2.05425 6.25879 3.311L11.826 8.87819V0.554688Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 31.4485C22.2212 30.8966 24.1059 29.9489 25.741 28.6922L20.1738 23.125V31.4485Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.125 20.1797L28.6922 25.7469C29.9489 24.1118 30.8967 22.2271 31.4485 20.1797H23.125Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9131H18.0871H18.087V0.135438C17.4038 0.0465 16.7073 0 16 0C15.2926 0 14.5962 0.0465 13.9131 0.135438V13.9129V13.913H0.135438C0.0465 14.5962 0 15.2927 0 16C0 16.7074 0.0465 17.4038 0.135438 18.0869H13.9129H13.913V31.8646C14.5962 31.9535 15.2926 32 16 32C16.7073 32 17.4038 31.9536 18.0869 31.8646V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7074 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 20.1719L27.3136 27.3117C27.642 26.9834 27.9552 26.6402 28.2541 26.2845L22.1415 20.1719H20.1738V20.1719Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 20.1719H11.8262L4.68652 27.3116C5.01477 27.6399 5.35796 27.9532 5.71371 28.2521L11.8263 22.1393V20.1719Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 11.8274V11.8273L4.68659 4.6875C4.35822 5.01575 4.04497 5.35894 3.74609 5.71469L9.85878 11.8274H11.8263V11.8274Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 11.8225L27.3136 4.68263C26.9854 4.35425 26.6422 4.041 26.2865 3.74219L20.1738 9.85487V11.8225Z",
    fill: "#D80027"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8427_52847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 32C44.8366 32 52 24.8366 52 16C52 7.16344 44.8366 0 36 0C27.1634 0 20 7.16344 20 16C20 24.8366 27.1634 32 36 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3037 16.0021H51.9993C51.9993 14.5579 51.8068 13.1589 51.4481 11.8281H35.3037V16.0021Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3037 7.6505H49.651C48.6715 6.05225 47.4192 4.63956 45.9591 3.47656H35.3037V7.6505Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9998 31.9939C39.7653 31.9939 43.2264 30.6924 45.9595 28.5156H26.04C28.7732 30.6924 32.2342 31.9939 35.9998 31.9939Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.348 24.3458H49.6512C50.4375 23.0628 51.0473 21.6603 51.4484 20.1719H20.5508C20.9518 21.6603 21.5617 23.0628 22.348 24.3458Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4115 2.49863H28.8696L27.5133 3.48394L28.0314 5.07825L26.6752 4.09294L25.319 5.07825L25.7665 3.70094C24.5724 4.69562 23.5257 5.861 22.6632 7.1595H23.1304L22.2671 7.78669C22.1326 8.01106 22.0036 8.239 21.88 8.47031L22.2922 9.73913L21.5231 9.18031C21.3319 9.58537 21.1571 9.99956 20.9999 10.4224L21.4541 11.8204H23.1304L21.7742 12.8057L22.2922 14.4L20.9361 13.4147L20.1237 14.0049C20.0424 14.6586 20 15.3243 20 16H36C36 7.1635 36 6.12175 36 0C32.8393 0 29.8928 0.916875 27.4115 2.49863ZM28.0314 14.4L26.6752 13.4147L25.319 14.4L25.8371 12.8057L24.4808 11.8204H26.1572L26.6752 10.2261L27.1932 11.8204H28.8696L27.5133 12.8057L28.0314 14.4ZM27.5133 8.14481L28.0314 9.73913L26.6752 8.75381L25.319 9.73913L25.8371 8.14481L24.4808 7.1595H26.1572L26.6752 5.56519L27.1932 7.1595H28.8696L27.5133 8.14481ZM33.7705 14.4L32.4143 13.4147L31.0581 14.4L31.5762 12.8057L30.2199 11.8204H31.8963L32.4143 10.2261L32.9323 11.8204H34.6087L33.2524 12.8057L33.7705 14.4ZM33.2524 8.14481L33.7705 9.73913L32.4143 8.75381L31.0581 9.73913L31.5762 8.14481L30.2199 7.1595H31.8963L32.4143 5.56519L32.9323 7.1595H34.6087L33.2524 8.14481ZM33.2524 3.48394L33.7705 5.07825L32.4143 4.09294L31.0581 5.07825L31.5762 3.48394L30.2199 2.49863H31.8963L32.4143 0.904312L32.9323 2.49863H34.6087L33.2524 3.48394Z",
    fill: "#0052B4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E5EEFC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8427_52847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8427_52847"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/us-flag.a52bb6e6ca2363b5561e156e427feb9c.svg";
export { ForwardRef as ReactComponent };